export default {
	venderId:state => state.loginUserInfo.venderId,
  suffix:state => state.loginUserInfo.suffix,
  loginUserInfo: state => state.loginUserInfo,
  pointUserInfo: state => state.pointUserInfo,
  shopInfo: state => state.shopInfo,
  isJhkPlatformSeller: state => state.isJhkPlatformSeller,
}